module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"404-text-1":"404 sivua ei löydy","404-text-2":"Jotain meni pieleen..","404-text-3":"Etusivulle"},"se":{"404-text-1":"404 sivua ei löydy","404-text-2":"Jotain meni pieleen..","404-text-3":"Etusivulle"},"en":{"404-text-1":"404 sivua ei löydy","404-text-2":"Jotain meni pieleen..","404-text-3":"Etusivulle"}}')
  delete Component.options._Ctor
}
